import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "py-4 flex flex-row justify-start items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-row py-6 h-full"
}
const _hoisted_5 = { class: "w-2/3 px-4 text-12px xxl:text-14px pb-20 overflow-y-auto" }
const _hoisted_6 = { class: "py-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "ID Leg", -1)
const _hoisted_8 = { class: "my-1 text-black-lp-300" }
const _hoisted_9 = { class: "py-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Leg", -1)
const _hoisted_11 = { class: "my-1 text-black-lp-300 capitalize w-2/3" }
const _hoisted_12 = { class: "py-3" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Leg Code", -1)
const _hoisted_14 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_15 = { class: "py-3" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Lokasi Awal", -1)
const _hoisted_17 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_18 = { class: "py-3" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Destinasi", -1)
const _hoisted_20 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_21 = { class: "py-3" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tipe Leg", -1)
const _hoisted_23 = { class: "my-1 text-gray-lp-300 px-2 inline-flex bg-gray-lp-200 rounded" }
const _hoisted_24 = { class: "border-t" }
const _hoisted_25 = { class: "pt-6 pb-3" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Vendor", -1)
const _hoisted_27 = { class: "my-1 text-black-lp-300" }
const _hoisted_28 = { class: "py-3" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Transport Moda", -1)
const _hoisted_30 = { class: "my-1 text-gray-lp-300 px-2 inline-flex bg-gray-lp-200 rounded" }
const _hoisted_31 = { class: "flex flex-row space-x-20" }
const _hoisted_32 = { class: "py-3" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Estimasi SLA Min. ", -1)
const _hoisted_34 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_35 = { class: "py-3" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Estimasi SLA Max. ", -1)
const _hoisted_37 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_38 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_39 = { class: "py-3" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status Leg", -1)
const _hoisted_41 = { class: "my-1 text-black-lp-300" }
const _hoisted_42 = { class: "flex" }
const _hoisted_43 = { class: "capitalize" }
const _hoisted_44 = { class: "py-3" }
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal Dibuat", -1)
const _hoisted_46 = { class: "my-1 text-black-lp-300" }
const _hoisted_47 = { class: "text-gray-lp-500" }
const _hoisted_48 = { class: "py-3" }
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir Diubah", -1)
const _hoisted_50 = { class: "my-1 text-black-lp-300" }
const _hoisted_51 = { class: "text-gray-lp-500" }
const _hoisted_52 = { class: "py-3 inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_button_fill = _resolveComponent("button-fill")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
        key: 0,
        onBack: _ctx.goBack
      }, null, 8, ["onBack"]))
    : (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            class: "w-5 mr-3 cursor-pointer",
            alt: "arrowLeft"
          }),
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.dataDetail.legName.length > 50
            ? `${_ctx.dataDetail.legName.substr(0, 50)}...`
            : _ctx.dataDetail.legName), 1)
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.errorCause,
              onTryAgain: _ctx.fetchDetailLeg
            }, null, 8, ["errorType", "onTryAgain"]))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("div", _hoisted_8, _toDisplayString(_ctx.dataDetail.id), 1)
                ]),
                _createVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.dataDetail.legName), 1)
                ]),
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.dataDetail.legCode), 1)
                ]),
                _createVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode("div", _hoisted_17, _toDisplayString(_ctx.dataDetail.legOrigin), 1)
                ]),
                _createVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode("div", _hoisted_20, _toDisplayString(_ctx.dataDetail.legDestination), 1)
                ]),
                _createVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode("div", _hoisted_23, _toDisplayString(_ctx.dataDetail.legType), 1)
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode("div", _hoisted_27, _toDisplayString(_ctx.dataDetail.vendorName), 1)
                  ]),
                  _createVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createVNode("div", _hoisted_30, _toDisplayString(_ctx.dataDetail.transport), 1)
                  ]),
                  _createVNode("div", _hoisted_31, [
                    _createVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createVNode("div", _hoisted_34, _toDisplayString(_ctx.dataDetail.minSla) + " Jam ", 1)
                    ]),
                    _createVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode("div", _hoisted_37, _toDisplayString(_ctx.dataDetail.maxSla) + " Jam ", 1)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_38, [
                _createVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode("div", _hoisted_41, [
                    _createVNode("div", _hoisted_42, [
                      _createVNode("div", {
                        class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.dataDetail.status.toLowerCase() === 'active'
                      ? 'bg-green-lp-300'
                      : 'bg-red-lp-600'
                  } ${
                    _ctx.dataDetail.status.toLowerCase() === 'active'
                      ? 'text-green-lp-200'
                      : 'text-red-lp-500'
                  }`
                
                      }, [
                        _createVNode("span", _hoisted_43, _toDisplayString(_ctx.dataDetail.status.toLowerCase()), 1)
                      ], 2)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createVNode("div", _hoisted_46, _toDisplayString(_ctx.createdAt), 1),
                  _createVNode("div", _hoisted_47, _toDisplayString(_ctx.createdBy), 1)
                ]),
                _createVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createVNode("div", _hoisted_50, _toDisplayString(_ctx.updatedAt), 1),
                  _createVNode("div", _hoisted_51, _toDisplayString(_ctx.updatedBy), 1)
                ]),
                _createVNode("div", _hoisted_52, [
                  _createVNode(_component_button_fill, {
                    onClick: _cache[2] || (_cache[2] = () => _ctx.goEdit(_ctx.id)),
                    title: "Edit",
                    class: "px-8 bg-red-lp-300"
                  })
                ])
              ])
            ]))
      ]))
}